import { useTranslation } from "react-i18next";
import * as React from "react";

import { GhostButton } from "turboui";
import classNames from "classnames";
import { IconSpeakerphone, IconBulb, IconMessage } from "turboui";

export function ZeroState() {
  return (
    <div>
      <Examples />
      <ExplanationAndButton />
    </div>
  );
}

function ExplanationAndButton() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-center items-center group">
      <div className="text-base font-bold">{t("Discussions")}</div>

      <div className="flex gap-2 mt-1 mb-4 text-center px-6 text-sm">
        {t("Post announcements, pitch ideas, and discuss ideas with your team.")}
      </div>

      <GhostButton size="sm">{t("Write a new post")}</GhostButton>
    </div>
  );
}

function Examples() {
  const { t } = useTranslation();
  return (
    <div className="relative w-full h-[170px] mt-10 opacity-75 px-[65px] flex flex-col gap-3">
      <Example icon={IconSpeakerphone} title={t("Post Announcements")} body={t("We have a new team member...")} />
      <Example icon={IconBulb} title={t("Pitch Ideas")} body={t("I have an idea to expand...")} />
      <Example icon={IconMessage} title={t("Discuss ideas")} body={t("We need to make a decision...")} />
    </div>
  );
}

function Example({ icon, title, body }: { icon: any; title: string; body: string }) {
  const iconClass = classNames(
    "bg-stone-300",
    "group-hover:bg-yellow-300",
    "group-hover:text-stone-900",
    "dark:bg-stone-600",
    "dark:group-hover:bg-yellow-500",
    "rounded-full p-1.5 transition-all",
  );

  return (
    <div className="flex items-center gap-2 group-hover:gap-3 transition-all shadow-sm pb-2">
      <div className={iconClass}>{React.createElement(icon, { size: 22, stroke: 1.5 })}</div>
      <div>
        <div className="font-bold text-[10px] leading-none">{title}</div>
        <div className="text-[10px]">{body}</div>
      </div>
    </div>
  );
}
